import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { tokenStore } from '@/lib/auth';
import { DashboardShell } from '@/components/dashboard/dashboard-shell';
import { TermsAcceptanceModal } from '@/components/shared/terms-acceptance-modal';
import { CategoryRequiredModal } from '@/components/shared/category-required-modal';
import { ClientCpfRequiredModal } from '@/components/shared/client-cpf-required-modal';

/**
 * Layout do dashboard — protege a rota e envolve as filhas (dashboard.index,
 * dashboard.agenda, dashboard.sessoes, ...) com o shell + sidebar.
 *
 * IMPORTANTE: rotas file-based no TanStack Router exigem `<Outlet />` no
 * componente do layout para renderizar as rotas filhas. Sem isso o match
 * acontece, mas a UI da filha nunca aparece.
 */
export const Route = createFileRoute('/dashboard')({
  beforeLoad: ({ location }) => {
    // Preserva o alvo original (path + query) pra que /login volte pra cá
    // após autenticar. Antes o redirect não passava `next`, então qualquer
    // fluxo "clicar em algo dentro de /dashboard sem estar logado" caía no
    // /dashboard genérico depois do login.
    if (!tokenStore.getAccess()) {
      const next = location.href; // já vem com search string embutida
      throw redirect({ to: '/login', search: { next } });
    }
  },
  component: DashboardLayout,
});

function DashboardLayout() {
  return (
    <DashboardShell>
      <Outlet />
      {/* Modal bloqueante de re-aceite — só aparece quando o user precisa */}
      <TermsAcceptanceModal />
      {/* F7 — categoria regulatória obrigatória pra terapeutas existentes */}
      <CategoryRequiredModal />
      {/* F4 — CPF obrigatório pra clientes existentes (NFSe opt-in) */}
      <ClientCpfRequiredModal />
    </DashboardShell>
  );
}
